module.exports = "<router-outlet> </router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main